module.exports = __webpack_public_path__ + "img/3.bb9b73c6.jpg";